"use strict";
exports.__esModule = true;
exports.APISEARCH_CONFIG = exports.APISEARCH_UI = exports.APISEARCH_DISPATCHER = exports.APISEARCH_STORE = exports.APISEARCH_REPOSITORY = void 0;
/**
 * Service constants
 */
exports.APISEARCH_REPOSITORY = "apisearch_repository";
exports.APISEARCH_STORE = "apisearch_store";
exports.APISEARCH_DISPATCHER = "apisearch_dispatcher";
exports.APISEARCH_UI = "apisearch_ui";
exports.APISEARCH_CONFIG = "apisearch_config";
